var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { Fragment } from "react";
import styled from "styled-components";
import PageHeader from "@atlaskit/page-header";
import Tooltip from "@atlaskit/tooltip";
import jiraLogo from "./jira.svg";
import confluenceLogo from "./confluence.svg";
import slackLogo from "./slack.svg";
import zoomLogo from "./zoom.svg";
import { ExerciseStatusButtons } from "../ExerciseStatusButtons";
import { ExerciseDueDate } from "../ExerciseDueDate";
export var ExercisePageHeader = function (_a) {
    var id = _a.id, name = _a.name, status = _a.status, dueDate = _a.dueDate, jiraUrl = _a.jiraUrl, confluenceUrl = _a.confluenceUrl, slackUrl = _a.slackUrl, zoomUrl = _a.zoomUrl, isExerciseBeingPrepared = _a.isExerciseBeingPrepared;
    var parentIssueId = jiraUrl.split("/").reverse()[0];
    var apps = [
        { name: parentIssueId || "Jira", url: jiraUrl, imgUrl: jiraLogo },
        { name: "Experiment Form", url: confluenceUrl, imgUrl: confluenceLogo },
        { name: "Slack", url: slackUrl, imgUrl: slackLogo },
        { name: "Zoom", url: zoomUrl, imgUrl: zoomLogo }
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(PageHeader, { disableTitleStyles: true, actions: React.createElement(ExerciseStatusButtons, { exerciseId: id, exerciseStatus: status }) },
            React.createElement("h2", null, name)),
        React.createElement(InfoBar, null,
            React.createElement(Apps, null, apps.map(function (_a) {
                var name = _a.name, url = _a.url, imgUrl = _a.imgUrl;
                var Container = url ? Fragment : Tooltip;
                return (React.createElement(AppLink, { href: url || undefined, key: name, isDisabled: isExerciseBeingPrepared, target: "_blank" },
                    React.createElement(Logo, { src: imgUrl, alt: name }),
                    React.createElement(Container, { content: "Creating " + name + " link..." },
                        React.createElement("span", null, name))));
            })),
            React.createElement(ExerciseDueDate, { dueDate: dueDate, exerciseId: id, exerciseName: name, isDisabled: isExerciseBeingPrepared }))));
};
var InfoBar = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var Apps = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  gap: 2rem;\n"], ["\n  display: flex;\n  gap: 2rem;\n"])));
var AppLink = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  filter: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  filter: ", ";\n"])), function (props) { return (props.isDisabled ? "grayscale(1)" : "none"); });
var Logo = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: 1rem;\n  width: 1rem;\n  margin-right: 0.5rem;\n"], ["\n  height: 1rem;\n  width: 1rem;\n  margin-right: 0.5rem;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
